import * as svg from "../../../assets/plus.svg";

import {iconBuilder} from "./iconBuilder";

export const PlusIcon = iconBuilder(svg, "PlusIcon", "0 0 10 10");
